import { render, staticRenderFns } from "./HomeDetails.vue?vue&type=template&id=73ad6bb5&"
import script from "./HomeDetails.vue?vue&type=script&lang=js&"
export * from "./HomeDetails.vue?vue&type=script&lang=js&"
import style0 from "./HomeDetails.vue?vue&type=style&index=0&id=73ad6bb5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports